export default {
  CodeEditor: {
    OpenAutocomplete: "Ctrl-Space",
    ShowTypeAndInfo: "Ctrl-I",
    OpenDocsLink: "Ctrl-O",
  },
};
